// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import {
    AddressValidationModel,
    AddressValidationResultModel,
    addressValidationService,
} from "@guestsupply/App/Services/AddressValidationService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    AddressValidationModel,
    ServiceResult<AddressValidationResultModel> & {
        errorMessage?: string;
        result?: AddressValidationResultModel;
    }
>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addressValidationService({ ...props.parameter });
    const { successful } = props.apiResult;

    props.dispatch({
        type: "xAddressValidation/SetAddressValidationData",
        addressValidation: successful ? props.apiResult?.result : { errorMessage: props.apiResult.errorMessage },
    } as any);
};

export const chain = [RequestDataFromApi];

const addressValidation = createHandlerChainRunner(chain, "AddressValidation");
export default addressValidation;
